import { ampli, BaseEvent } from '.';

/* This function will retry ampli events for 10 seconds so that we don't lose events
It is due to race condition nature of AmpliProvider. 
Ampli may not finish loading at the time of attempting sending initial tracking request
*/
export const sendAmpliEvent = (event: BaseEvent, attempts = 0) => {
  const MAX_ATTEMPTS = 10;
  try {
    sendEvent(event);
  } catch {
    if (attempts < MAX_ATTEMPTS) {
      setTimeout(() => {
        sendAmpliEvent(event, attempts + 1);
      }, 1000);
    }
  }
};

const sendEvent = (event: BaseEvent) => {
  if (!ampli?.isLoaded) {
    throw new Error('Ampli is not initialised yet');
  }
  ampli.client.track({
    ...event,
  });
};
